import {
  Box,
} from '@warp-ds/react';
import React from 'react';
import { formatToNorwegianPrice } from '../../utils/priceUtil';

type JobSegmentCardProps = {
  categoryName: string,
  categoryDescription?: string | undefined,
  price: number,
  discountedPrice: number,
  showDiscountedPrices: boolean,
};
export default function JobSegmentCard({
  categoryName, categoryDescription, price, discountedPrice, showDiscountedPrices,
}: JobSegmentCardProps) {
  return (
    <Box className="p-0! w-full h-full" bordered>
      <div className="mt-24 mx-16 mb-16! flex flex-row lg:flex-col">
        <div className="w-2/5 lg:w-full">
          <p className="font-bold text-m">{categoryName}</p>
          { categoryDescription && <p className="text-s mb-0">{categoryDescription}</p> }
        </div>
        {showDiscountedPrices ? (
          <div className="w-3/5 lg:w-full text-right lg:text-left">
            <p className="text-s mb-0 lg:pt-16">Ordinær pris</p>
            <p className="line-through text-s">
              {formatToNorwegianPrice(price)}
              {' '}
              kr
            </p>
            <p className="text-s mb-0 pt-16">Din pris</p>
            <p className="text-s mb-0">Basisannonse</p>
            <p className="text-m font-bold mb-0">
              {formatToNorwegianPrice(discountedPrice)}
              {' '}
              kr
            </p>
          </div>
        ) : (
          <div className="mt-12 lg:mt-32 w-3/5 lg:w-full text-right lg:text-left">
            <p className="text-s mb-0">Basisannonse</p>
            <p className="text-m font-bold">
              {formatToNorwegianPrice(price)}
              {' '}
              kr
            </p>
          </div>
        )}
      </div>
    </Box>
  );
}

JobSegmentCard.defaultProps = { categoryDescription: undefined };
